import "./App.css";
import Wrapper from "./components/Wrapper/Wrapper";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}

export default App;
